import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { PaginatedSearchResultMatchSearchResultDTO } from '@solverml/api';
import { StatisticsStateService } from '../../controller/statistics-state.service';
import {StatisticsMatchCardComponent} from "../statistics-match-card/statistics-match-card.component";


@Component({
  selector: 'app-search-tab-match',
  templateUrl: './search-tab-match.component.html',
  styleUrls: ['./search-tab-match.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatIconModule,
    StatisticsMatchCardComponent
  ]
})
export class SearchTabMatchComponent {

  private state = inject(StatisticsStateService);

  public matchesResult$: Observable<PaginatedSearchResultMatchSearchResultDTO | null>;
  public isLoading$: Observable<boolean>;

  constructor() {
    this.matchesResult$ = this.state.matchesResult$;
    this.isLoading$ = this.state.isLoadingData$;
  }

  /**
   * Gestiona el evento de cambio de página del paginador.
   */
  public handlePageEvent(e: PageEvent): void {
    this.state.paginateMatches(e.pageIndex + 1);
  }
}
